import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addCrewMemberData,
  deleteCrewMemberData,
  fetchCrewListData,
  processCrewDocumentData,
  updateCrewMemberData,
} from "../../apis/crew";

import type { CrewMember } from "../../utils/types/crew";

export const fetchCrewList = createAsyncThunk(
  "crew/fetchCrewList",
  async ({ jobId }: { jobId: string }, { rejectWithValue }) => {
    try {
      const data = await fetchCrewListData(jobId);
      return { jobId, data };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Fires and returns — completion is delivered via WebSocket (crew_complete / crew_failed)
export const processCrewDocument = createAsyncThunk(
  "crew/processCrewDocument",
  async (
    {
      jobId,
      documentId,
      key,
      bucket,
    }: {
      jobId: string;
      documentId?: string;
      key?: string;
      bucket?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await processCrewDocumentData({ jobId, documentId, key, bucket });
      return { jobId };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createCrewMember = createAsyncThunk(
  "crew/createCrewMember",
  async (
    { jobId, data }: { jobId: string; data: Partial<CrewMember> },
    { rejectWithValue }
  ) => {
    try {
      const member = await addCrewMemberData(jobId, data);
      return { jobId, member };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateCrewMember = createAsyncThunk(
  "crew/updateCrewMember",
  async (
    { id, jobId, data }: { id: string; jobId: string; data: Partial<CrewMember> },
    { rejectWithValue }
  ) => {
    try {
      const member = await updateCrewMemberData(id, jobId, data);
      return { jobId, member };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteCrewMember = createAsyncThunk(
  "crew/deleteCrewMember",
  async (
    { id, jobId }: { id: string; jobId: string },
    { rejectWithValue }
  ) => {
    try {
      await deleteCrewMemberData(id);
      return { jobId, id };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
